import { Entity, MicroMClient } from "@mcurros2/microm";
import { RutasTiendasFiltersDef } from "./RutasTiendasFiltersDef";


export class RutasTiendasFilters extends Entity<RutasTiendasFiltersDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new RutasTiendasFiltersDef(), parentKeys);
        this.Form = import('./RutasTiendasFiltersForm').then((module) => module.RutasTiendasFiltersForm);
        this.Title = "Filtros de Ruteo";
    }
}